import { render, staticRenderFns } from "./staffManagement.vue?vue&type=template&id=449a0d6e&scoped=true&"
import script from "./staffManagement.vue?vue&type=script&lang=js&"
export * from "./staffManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a0d6e",
  null
  
)

export default component.exports